import "./loginform.css"; 
import frecce from "../images/frecce.png"
import config from "../images/config.png"
import { Link } from "react-router-dom"; 

function LoginForm({
  username,
  password,
  setUsername,
  setPassword,
  onSubmit,
  isConfigurator,
  setIsConfigurator,
  message
}) {
  return (
    <div className={`d-flex align-items-center justify-content-center vh-100 ${isConfigurator ? "bg-configurator" : "bg-body-tertiary"} bg-transition`}>
      <main className="form-signin w-100 m-auto" style={{ maxWidth: "330px" }}>

        <div className="checkbox-container text-center">
          <img src={config} alt="Icona configuratore" className="checkbox-image" />
          <button
            type="button"
            className={`btn ${isConfigurator ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setIsConfigurator(!isConfigurator)}
          >
            {isConfigurator ? "Accedi qua come fruitore" : "Accedi qua come configuratore"}
          </button>
        </div>

        <form onSubmit={onSubmit}>
          <img
            className="w-100" 
            src= {frecce}
            alt=""
            width="50"
            height="150"
          />
          <h1 className="h3 mb-3 fw-normal text-center" style={{ color: isConfigurator ? "white" : "black" }}>
            Accedi al tuo account {isConfigurator ? "Configuratore" : "Fruitore"}!
          </h1>

          <div className="form-floating">
            <input
              type="text"
              className="form-control"
              id="floatingInput"
              placeholder="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <label htmlFor="floatingInput">Username</label>
          </div>

          <div className="form-floating mb-4">
            <input
              type="password"
              className="form-control"
              id="floatingPassword"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label htmlFor="floatingPassword">Password</label>
          </div>


          <button className="btn btn-primary w-100 py-2" type="submit">
            Accedi
          </button>

           <p className="h5 fw-normal " style={{ color: isConfigurator ? "white" : "black", marginTop: "18px" }}>Non hai un account?&nbsp;&nbsp;  
             <Link to={isConfigurator ? "/register" : "/registeruser"}>Registrati</Link>
           </p>
           
           {message && (<div className="alert alert-info mt-4 text-center"> {message} </div> )}

        </form>
      </main>
    </div>
  );
}

export default LoginForm;
